import cn from '@/utils/cn';
import styles from './Tag.module.css';

interface TagProps {
  children: React.ReactNode;
  bgColor?: 'grey' | 'transparent';
  color?: 'black' | 'white';
}

function Tag({ children, bgColor = 'grey', color = 'black' }: TagProps) {
  return <div className={cn([styles.tag, styles[`color-${color}`], styles[`background-${bgColor}`]])}>{children}</div>;
}

export default Tag;
